
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as PrismicPreviewOcMDyPIjGheJ09J_450PKOgW2wXAfUzgHKqquyWIcmSYcMeta } from "/vercel/path0/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue?macro=true";
import { default as legalk0TLVEiHS0rRZk_45dGgxPMSO_sTIlOdzIF2DYnz4vk24Meta } from "/vercel/path0/pages/legal.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indexDIlA_VwVYEsF82JYYTptIRBexsOVSbsbgl1xBQ_lIIoMeta } from "/vercel/path0/pages/blog/index.vue?macro=true";
import { default as index_458vuJqw0Xb3tR3m8I7PP6NNQXjQ6CArtQDKcGQjKy3UMeta } from "/vercel/path0/pages/work/index.vue?macro=true";
import { default as indexdW670_4563LDuILksGHTznS0mHyGjoe6Ar6P3C6d_45G8r0Meta } from "/vercel/path0/pages/contact/index.vue?macro=true";
import { default as cookie_45policyXq_8Z0Flba748deoRdQ0oMVSHcZLV_jcLf_uNOOBZ_45oMeta } from "/vercel/path0/pages/cookie-policy.vue?macro=true";
import { default as privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as indexoYxHHSMtHe5R8sdKDX8XZROwzo2V1dhDknGfyFeHMVQMeta } from "/vercel/path0/pages/[landing]/index.vue?macro=true";
import { default as successpNWga3y_YlkVZ60z50PCmyeJ59rAijP__aFQ3wEOMUAMeta } from "/vercel/path0/pages/contact/success.vue?macro=true";
import { default as slice_45simulator_OjKnhIyDXYQMh_451hfsvK1gAKx2giehyTcKMoPBK0RYMeta } from "/vercel/path0/pages/slice-simulator.vue?macro=true";
import { default as indexNC29plipfwX6t1vi9sEQs5tIeW2S5CnmiWVkbUe8maYMeta } from "/vercel/path0/pages/blog/[post]/index.vue?macro=true";
import { default as indexPFoKlXpHS2Sg7ysUAErEWjVSLH9L8dchHNOXDwz9q2AMeta } from "/vercel/path0/pages/work/[work]/index.vue?macro=true";
import { default as indexec5UXuqKqMRx79QqNB5nUfsOJBujdzg5LSL3WEPyXf8Meta } from "/vercel/path0/pages/forms/[form]/index.vue?macro=true";
import { default as successvPLpiU0ptRi8dQlJRZcufpG1STkbtRVbhMfazgNEPfIMeta } from "/vercel/path0/pages/forms/[form]/success.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "prismic-preview",
    path: "/preview",
    component: () => import("/vercel/path0/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: {"slug":"cookie-policy"},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "data-retention-policy",
    path: "/data-retention-policy",
    meta: {"slug":"data-retention-policy"},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "data-protection-policy",
    path: "/data-protection-policy",
    meta: {"slug":"data-protection-policy"},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: {"slug":"privacy-policy"},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog/index.vue")
  },
  {
    name: "work",
    path: "/work",
    component: () => import("/vercel/path0/pages/work/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact/index.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/vercel/path0/pages/cookie-policy.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "landing",
    path: "/:landing()",
    component: () => import("/vercel/path0/pages/[landing]/index.vue")
  },
  {
    name: "contact-success",
    path: "/contact/success",
    component: () => import("/vercel/path0/pages/contact/success.vue")
  },
  {
    name: "slice-simulator",
    path: "/slice-simulator",
    component: () => import("/vercel/path0/pages/slice-simulator.vue")
  },
  {
    name: "blog-post",
    path: "/blog/:post()",
    component: () => import("/vercel/path0/pages/blog/[post]/index.vue")
  },
  {
    name: "work-work",
    path: "/work/:work()",
    component: () => import("/vercel/path0/pages/work/[work]/index.vue")
  },
  {
    name: "forms-form",
    path: "/forms/:form()",
    component: () => import("/vercel/path0/pages/forms/[form]/index.vue")
  },
  {
    name: "forms-form-success",
    path: "/forms/:form()/success",
    component: () => import("/vercel/path0/pages/forms/[form]/success.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/people",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/insight/",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/marketing-ai",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/ai",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/eightandfour-secures-a-double-nomination-at-the-global-social-media-awards",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/an-update-from-eightampfour-from-setting-this-years-agenda-to-welcoming-exciting-new-clients",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/eightampfour-gets-shortlisted-for-best-agency-culture-award-at-the-oystercatchers-2023",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/what-weve-been-up-to-in-november-canon-hero-video-marie-curie-brand-campaign-and-more",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/yg8i3kycqwvw9k23b20qz0mvj2rx64",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/updates-from-eightampfourians-new-wins-live-content-development-and-creative-success",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/the-drum-awards-festival-weve-been-nominated-twice-for-genesis-and-mind",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/unwrapping-success-standing-out-in-the-christmas-crowd",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/eightampfour-takes-home-double-win-at-ipm-awards",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/influencer-marketing",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/eightandfour-scores-a-prestigious-double-shortlisting-in-two-categories-at-the-european-agency-awards-2023",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/double-shortlist-nomination-for-eightampfour-at-the-ipm-awards-with-sandals-resorts-and-genesis-europenbsp",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/uk-social-media-awards-eightampfour-gets-shortlisted-in-three-categories",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/ai-x-creative-how-generative-artificial-intelligence-can-support-creativity",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/why-social-commerce-in-2023",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/ai-roadmap",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/insight/blog/eightampfour-wins-best-use-of-social-media-at-automotive-marketing-amp-communications-awards-for-work-with-genesis",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/blog/insight/30-secondsgoogle-hummingbird-algorithm",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]